import { Directive, HostListener, ElementRef, Optional, Input } from '@angular/core';
import { NgControl, FormControl } from '@angular/forms';

@Directive({
  selector: '[removeSpaces]'
})
export class RemoveSpacesDirective {

  constructor(@Optional() private formControl: NgControl) { }

  @HostListener('input', ['$event']) onInput(event: any) {
    if(this.formControl.control!.value) {
      if(!/\s/g.test(this.formControl.control!.value)) {
        return;
      } else {
        if (this.formControl) {
          this.formControl.control!.patchValue(this.formControl.control!.value.replaceAll(/\s/g,''));
        }
      }
    } 
  }

}
